<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-spacer />
        <div class="title">Michaelis Cabin</div>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app :temporary="$vuetify.breakpoint.smAndDown" :permanent="$vuetify.breakpoint.mdAndUp && drawer">
      <template v-slot:prepend>
        <v-list-item style="height: 64px">
          <v-list-item-avatar v-if="user && user.photoURL">
            <img :src="user.photoURL" />
          </v-list-item-avatar>
          <!-- user content -->
          <v-list-item-content v-if="user && !isGuest">
            <v-list-item-title>{{ user.displayName }}</v-list-item-title>
            <v-list-item-subtitle class="subheader" @click="logout">logout</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content v-else-if="user && isGuest">
            <v-list-item-title>Guest User</v-list-item-title>
            <v-list-item-subtitle class="subheader" @click="logout">logout</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-btn @click="navigateTo('login')">Login</v-btn>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item v-for="(item, idx) in menuItems" :key="idx"
            @click="navigateTo(item.pathName)">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>      
      <router-view />
    </v-main>
    <v-snackbar v-model="snackbar" bottom :timeout="1500">
      {{ snackbarText }}
    </v-snackbar>
    <SeeMoreDialog ref="seeMore" />
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { auth } from '@/plugins/firebase'
import bus from '@/helpers/bus'

import SeeMoreDialog from '@/components/SeeMoreDialog'

export default {
  components: { SeeMoreDialog },
  data: () => ({
    drawer: null,
    menuItems: [
      { title: 'Home', pathName: 'home' },
      { title: 'Stories', pathName: 'stories' },
      { title: 'Birds', pathName: 'birds' },
      { title: 'Plants', pathName: 'plants' },
      { title: 'Photos', pathName: 'photos' },
      { title: 'About', pathName: 'about' }
    ],
    snackbar: false,
    snackbarText: ''
  }),
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isGuest'])
  },
  methods: {
    navigateTo(name) {
      if (this.$route.name === name) {
        // close the navigation drawer only
        this.drawer = false
      } else {
        // navigate to the page which will close the drawer also
        this.$router.push({ name })
      }
    },
    async logout() {
      try {
        await auth.signOut()
        await this.$store.commit('SET_USER', null)
        this.$router.push('login')
      } catch(e) {
        return Promise.reject(e)
      }
    }
  },
  created() {
    bus.$on('snackbar', text => {
      this.snackbarText = text
      this.snackbar = true
    }, () => {})
    bus.$on('see-more', images => {
      this.$refs.seeMore.open(images)
    }, () => {})
  }
};
</script>
